module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/031-corsica-c9f0d91f1ea6cae14e2fa5a564dd6b8d.svg";